import React, { useEffect } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import fields from './fields';
import PersonalInformationFields from './PersonalInformationFields';
import validator from './validate';
import CompliantFooterLinksDE from '../../components/ComplaintFooterLinksDE/CompliantFooterLinksDE';
import FormStepHeading from '../../components/FormStepHeading/FormStepHeading';
import { getAmplitudeDefaultEventProperties } from '../../tracking/amplitudeEvents';
import commonMessages from '../Containers.messages';

type PersonalInformationProps = {
    formKey?: string;
    companyType?: string;
};

const PersonalInformation = (props: PersonalInformationProps) => {
    useEffect(() => {
        tracking.ampli.stepLoaded({
            'Step name': 'Personal details',
            ...getAmplitudeDefaultEventProperties()
        });
    }, []);

    return (
        <React.Fragment>
            <FormStepHeading>
                <FormattedMessage {...commonMessages.personalInformation} />
            </FormStepHeading>
            <PersonalInformationFields
                // TODO: fix this when redux form is removed
                // @ts-ignore
                fields={fields}
                asyncValidate={validator}
                asyncBlurFields={_.without(
                    fields,
                    'people[].privacy_policy_agreement_date'
                )}
                {...props}
                formKey="personalInformation"
            />
            <CompliantFooterLinksDE />
        </React.Fragment>
    );
};

export default PersonalInformation;
